// Cache dell'ultimo account autenticato: alimenta il bottone login "Continua come <nome>".
// Sopravvive al logout (pattern Gmail/Microsoft): l'utente viene riconosciuto al
// ritorno senza rivelare nulla oltre cio' che la macchina gia' sapeva.
// Nessuna dipendenza: modulo replicabile in qualsiasi progetto del Genoma.

export interface LastAccount {
  name: string;
  email: string;
  avatar: string;
}

const DEFAULT_KEY = 'genome:last-account';

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function resolveStorage(custom?: StorageLike): StorageLike | null {
  if (custom) return custom;
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch {
    /* storage inaccessibile (SSR, privacy mode) */
  }
  return null;
}

export function readLastAccount(storageKey = DEFAULT_KEY, storage?: StorageLike): LastAccount | null {
  const s = resolveStorage(storage);
  if (!s) return null;
  try {
    const raw = s.getItem(storageKey);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    const email = typeof data.email === 'string' ? data.email : '';
    const name = typeof data.name === 'string' ? data.name : '';
    const avatar = typeof data.avatar === 'string' ? data.avatar : '';
    if (!email && !name) return null;
    return { name, email, avatar };
  } catch {
    return null;
  }
}

// Salta i payload vuoti: un profilo senza ne' nome ne' email non e' un account
// riconoscibile e non deve inquinare il bottone.
export function rememberLastAccount(
  profile: { name?: unknown; email?: unknown; avatar?: unknown },
  storageKey = DEFAULT_KEY,
  storage?: StorageLike
): void {
  const s = resolveStorage(storage);
  if (!s) return;
  const name = typeof profile?.name === 'string' ? profile.name : '';
  const email = typeof profile?.email === 'string' ? profile.email : '';
  const avatar = typeof profile?.avatar === 'string' ? profile.avatar : '';
  if (!email && !name) return;
  try {
    s.setItem(storageKey, JSON.stringify({ name, email, avatar }));
  } catch {
    /* quota piena o storage bloccato: feature best-effort */
  }
}

export function forgetLastAccount(storageKey = DEFAULT_KEY, storage?: StorageLike): void {
  const s = resolveStorage(storage);
  if (!s) return;
  try {
    s.removeItem(storageKey);
  } catch {
    /* no-op */
  }
}
